import {
  Group,
  Paper,
  Space,
  Text,
  SimpleGrid,
  UnstyledButton,
  Accordion,
  Center,
} from "@mantine/core";
import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useServerApi } from "../hooks/userServerApi";

import {
  IconUsers,
  IconUser,
  IconCircleCheck,
  IconNotes,
  IconTableImport,
  IconCirclePlus,
  IconUserCircle,
  IconBuildingBank,
  IconCircleMinus,
  IconActivity,
  IconCircleX,
  IconHeart,
  IconNote,
} from "@tabler/icons";

import CardStat from "./cardStat";
import { useAuthUser } from "react-auth-kit";

const RenewalPageStats = forwardRef(
  ({ cols = 5, role, preQuery, ...props }, ref) => {
    const [api] = useServerApi();

    const [stats, setStats] = useState([]);
    const auth = useAuthUser();

    let result = null;
    const fetchStats = async () => {
      try {
        // switch (role) {
        //   case "OPERATION":
        //     result = await api.Renewal.getStatSummary();
        //     break;
        //   case "CONSULTANT":
        //     // result = await api.DebitNote.getStatSummaryByConsultant(auth().id);
        //     result = await api.Renewal.getStatSummary();

        //     break;
        // }
        // console.log("result", result);
        result = await api.Renewal.getStatSummary(preQuery);
        if (!result || !result.data) return;

        const { stats } = result.data;
        setStats([
          {
            icon: IconNotes,
            color: "#0ED1EA",
            label: "TOTAL",
            msg: stats.TOTAL ?? 0,
          },

          {
            icon: IconCircleMinus,
            color: "#FF9F43",
            label: "DFT",
            msg: stats.DFT ?? 0,
          },
          {
            icon: IconCircleMinus,
            color: "orange",
            label: "PENDING",
            msg: stats.PENDING ?? 0,
          },
          {
            icon: IconCircleMinus,
            color: "orange",
            label: "WAIT",
            msg: stats.WAIT ?? 0,
          },
          {
            icon: IconCircleCheck,
            color: "green",
            label: "CONFIRM",
            msg: stats.CONFIRM ?? 0,
          },

          {
            icon: IconCircleX,
            color: "red",
            label: "TERMINATE",
            msg: stats.TERMINATE ?? 0,
          },

          // {
          //   icon: IconNotes,
          //   color: "#8278F2",
          //   label: "NEW BIZ",
          //   msg: result.stats.PENDING ?? 0,
          // },
          // {
          //   icon: IconTableImport,
          //   color: "#FF9F43",
          //   label: "TRANSFER IN",
          //   msg: result.stats.INDIVIDUAL ?? 0,
          // },
        ]);
      } catch (error) {
        console.log(error);
      }
    };

    useImperativeHandle(ref, () => ({
      refresh: fetchStats,
    }));

    useEffect(() => {
      fetchStats();
    }, [preQuery]);

    return (
      <>
        <SimpleGrid
          cols={cols}
          breakpoints={[{ maxWidth: "sm", cols: 1 }]}
          {...props}
        >
          {stats?.map((stat, index) => (
            <CardStat key={index} stat={stat} />
          ))}
        </SimpleGrid>
      </>
    );
  }
);

export default RenewalPageStats;
